<template>
  <fts-popper 
    :append-to-body="appendToBody" 
    :trigger="trigger" 
    :placement="placement" 
    :prevent-overflow-padding="preventOverflowPadding"
    :offset="offset" 
    :overlay="overlay" 
    class="fts-display-profile-card"
  >
    <div 
      slot="content" 
      class="display-profile-card-content" 
      :class="appendContentClass" 
    >
      <fts-profile 
        :profile="profile" 
        :profile-name="false" 
        :profile-photo-size="21"
        class="profile-card-photo"
      />

      <div class="profile-card-wrapper">
        <div>{{profileName || '(undefined)'}}</div>
        <div class="profile-card-info" v-if="profile">
          <template v-if="profile.displayName">
            <span>{{profile.displayName}}</span>
            <span class="fts-inline-spacer-1"></span>
          </template>
          <span class="profile-card-username">{{profile.username}}</span>
        </div>
      </div>
    </div>

    <div 
      slot="reference" 
      class="display-profile-card-trigger" 
      :class="appendTriggerClass"
    >
      {{profileName}}
    </div>
  </fts-popper>
</template>

<script>
import FTSPopper from './FTSPopperNew';
import FTSProfile from './FTSProfile';

export default {
  props: {
    appendToBody: Boolean,
    trigger: {
      type: String,
      default: "click",
    },
    placement: {
      type: String,
      default: "top"
    },
    preventOverflowPadding: {
      type: [Number, Object],
      default: 16
    },
    offset: {
      type: [Array, Function],
      default: () => [0, 6]
    },
    overlay: {
      type: Boolean,
      default: true
    },
    profile: Object,
    profileName: String,
    users: Array,
    appendTriggerClass: String,
    appendContentClass: String
  },
  components: {
    'fts-popper': FTSPopper,
    'fts-profile': FTSProfile
  }
}
</script>

<style lang="scss" scoped>
.fts-display-profile-card {
  .display-profile-card-trigger {
    color: var(--fts-primary);
    cursor: pointer;
  }
}

.display-profile-card-content {
  width: 300px;
  max-width: 300px;
  display: flex;
  align-items: flex-start;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  .profile-card-photo {
    flex-shrink: 0;
    margin-right: 0.375rem;
  }
  .profile-card-info {
    font-size: 0.75rem;
    overflow-wrap: anywhere;
    word-break: break-all;
  }  
  .profile-card-username {
    color: var(--fts-default);
  }
}
</style>